import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { OptionType } from 'src/app/core/enums/enums';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { Airline, Currency } from 'src/app/core/models/models';
import { Location } from 'src/app/core/models/itinerary.model';
import * as SettingsActions from '../actions/settings.actions';

export interface SettingsState {
  clientSettings: IClientSettings;
  currencies: Currency[];
}

export const initialSettingsState: SettingsState = {
  clientSettings: null,
  currencies: null
};

const SettingsReducer = createReducer(
  initialSettingsState,
  on(SettingsActions.LoadClientSettingsSuccess, (state, { settings }) => ({
    ...state,
    clientSettings: settings
  })),
  on(SettingsActions.LoadCurrenciesSuccess, (state, { currencies }) => ({
    ...state,
    currencies
  }))
);

export function reducer(state: SettingsState | undefined, action: Action): SettingsState {
  return SettingsReducer(state, action);
}

export const selectSettingsState = createFeatureSelector<SettingsState>(OptionType.Settings);

export const selectClientSettings = createSelector(
  selectSettingsState,
  (state) => state.clientSettings
);

export const selectClientIsAirline = createSelector(
  selectSettingsState,
  (state) => state.clientSettings.isAirline
);

export const selectCurrencies = createSelector(selectSettingsState, (state) => state.currencies);
